import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "arrow_back",
		d: "M3.825 9.5L9.425 15.1L8 16.5L0 8.5L8 0.5L9.425 1.9L3.825 7.5H16V9.5H3.825Z",
		fill: "currentColor",
		style: {
			fill: "currentColor",
			fillOpacity: 1
		}
	})
});
export default SvgBackArrow;
